import axios from "axios";

// 获取多音字字典
let polyphoneDict = null;
const POLYPHONE_DICT_KEY = "POLYPHONE_DICT_CACHE";
const nameMap = ["1声", "2声", "3声", "4声", "轻声"]
function initPolyphoneDict(data) {
    polyphoneDict = []
    for (let key in data) {
        const nameIndex = key[key.length - 1] - 1
        polyphoneDict.push([key, data[key], nameMap[nameIndex]]);
    }
    polyphoneDict.sort((a, b) => {
        return a[0] === b[0] ? 0 : a[0] > b[0] ? 1 : -1
    })
    // @ts-ignore
    // window.polyphoneDict = polyphoneDict
}
function getPolyphoneDict() {
    return axios
        .get("/nodetts-apis/tts/polyphoneDictList")
        .then((res) => res.data)
        .then(({ code, data }) => {
            if (code === 200) {
                localStorage.setItem(POLYPHONE_DICT_KEY, JSON.stringify(data))
                initPolyphoneDict(data);
            }
        })
        .catch(() => { });
}
const storage = localStorage.getItem(POLYPHONE_DICT_KEY);
if (storage) {
    initPolyphoneDict(JSON.parse(storage));
}
getPolyphoneDict();

export default function findTonesByPrifix(prefix) {
    const left = findLeftBound(prefix)
    const res = []
    if (left === -1) return res
    for (let i = left; i < polyphoneDict.length; i++) {
        if (polyphoneDict[i][0].startsWith(prefix)) {
            res.push(polyphoneDict[i])
        } else {
            break;
        }
    }
    return res
}

function findLeftBound(prefix) {
    if (prefix === '') return -1
    let left = 0, right = polyphoneDict.length - 1, mid = 0
    if ((polyphoneDict[left][0] > prefix && !polyphoneDict[left][0].startsWith(prefix)) ||
        polyphoneDict[right][0] < prefix
    ) {
        return -1
    }
    while (left <= right) {
        mid = left + Math.floor((right - left) / 2)
        if (polyphoneDict[mid][0].startsWith(prefix)) {
            right = mid - 1
        } else if (polyphoneDict[mid][0] < prefix) {
            left = mid + 1
        } else {
            right = mid - 1
        }
    }
    if (left === polyphoneDict.length) return -1
    return polyphoneDict[left][0].startsWith(prefix) ? left : -1
}